import { useQuery, useQueryClient } from '@tanstack/react-query'

import { integrationAPI } from '@/api/new-api'

type GetSaltoSpaceAccessPointsRequest = {
  buildingId: number
}

export type SaltoSpaceAccessPoint = {
  saltoId: string
  name: string
  extPartitionId?: string
}

export type SaltoSpaceAccessPoints = {
  doors: SaltoSpaceAccessPoint[]
  permissionGroups: SaltoSpaceAccessPoint[]
  accessLevels: SaltoSpaceAccessPoint[]
}

export const getSaltoSpaceAccessPointsQueryKey = (data: GetSaltoSpaceAccessPointsRequest) => [
  'useGetSaltoSpaceAccessPoints',
  data,
]

// NOTE: integrationAPI — this proxies Salto live, so a vendor 401 must not end the admin's session
const getSaltoSpaceAccessPoints = async (data: GetSaltoSpaceAccessPointsRequest) => {
  const response = await integrationAPI.get<SaltoSpaceAccessPoints>(
    `/salto-space/access-points/${data.buildingId}`,
  )
  return response.data
}

export const useGetSaltoSpaceAccessPoints = (
  data: GetSaltoSpaceAccessPointsRequest,
  enabled = true,
) =>
  useQuery({
    enabled: enabled && Boolean(data.buildingId),
    queryFn: () => getSaltoSpaceAccessPoints(data),
    queryKey: getSaltoSpaceAccessPointsQueryKey(data),
  })

export const useInvalidateSaltoSpaceAccessPoints = () => {
  const queryClient = useQueryClient()
  return () => queryClient.invalidateQueries({ queryKey: ['useGetSaltoSpaceAccessPoints'] })
}
